import type { FC } from 'react';

import { StyledLink } from 'components/atoms/StyledLink';
import { ArrowRightLine } from 'components/icons/System';
import { AppLink } from 'types/AppLink';

interface Props {
  title: string;
  links: AppLink[];
  externalLinks?: boolean;
}

export const FooterLinkList: FC<Props> = ({
  title,
  links,
  externalLinks = false,
}) => (
  <div>
    <h2 className="mb-4 h5">{title}</h2>
    <ul className="list-none">
      {links.map((link) => (
        <li key={link.href} className="mb-4 list-none last:mb-0">
          {!externalLinks ? (
            <StyledLink link={link} underline={false} />
          ) : (
            <StyledLink
              className="w-full"
              iconClassName="ml-auto"
              link={link}
              underline={false}
              icon={ArrowRightLine}
            />
          )}
        </li>
      ))}
    </ul>
  </div>
);
